<template>
  <div class="app-card run-init-card">
    <el-form
      :model="form"
      :rules="formRules"
      ref="form"
      label-position="top"
      size="small"
    >
      <el-row :gutter="16">
        <el-col :span="6">
          <el-form-item :label="$t('text.tester')" prop="testerName">
            <el-input v-model="form.testerName" style="width:100%" />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item :label="$t('text.product')" prop="product">
            <el-select
              v-model="form.productId"
              :placeholder="$t('text.please_select')"
              filterable
              class="filter-selelct"
              style="width:100%"
            >
              <el-option
                v-for="item in products"
                :key="item.id"
                :label="item.productName"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item :label="$t('text.pod')" prop="pod">
            <el-select
              v-model="form.pod"
              :placeholder="$t('text.please_select')"
              filterable
              class="filter-selelct"
              style="width:100%"
            >
              <el-option
                v-for="item in podsOptions"
                :key="item.value"
                :label="item.value"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item :label="$t('text.position')" prop="position">
            <el-select
              v-model="form.position"
              :placeholder="$t('text.please_select')"
              style="width:100%"
            >
              <el-option
                v-for="item in positionOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="16">
        <el-col :span="6">
          <el-form-item :label="$t('text.weight')" prop="comments">
            <el-input v-model="form.comments" style="width:100%">
              <template slot="append"
                >kg</template
              >
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <div class="form-actions">
      <span class="incomplete-hint" v-if="incompleteRunRecord">
        {{ $t('text.incomplete_run') }}:
        {{
          userLang.indexOf('en') > -1
            ? moment
                .utc(incompleteRunRecord.charData.startedTime)
                .tz(utcOffset)
                .format('DD MMM YY')
            : moment
                .utc(incompleteRunRecord.charData.startedTime)
                .tz(utcOffset)
                .format('DD/MM/YY')
        }}
        @
        {{
          moment
            .utc(incompleteRunRecord.charData.startedTime)
            .tz(utcOffset)
            .format('h:mm a')
        }}
      </span>
      <el-button
        v-if="incompleteRunRecord"
        type="primary"
        plain
        size="small"
        @click="goContinue()"
      >
        {{ $t('text.continue').toUpperCase() }}
      </el-button>
      <el-button type="primary" plain size="small" @click="goStart()">
        {{ $t('text.start_new').toUpperCase() }}
      </el-button>
    </div>
  </div>
</template>

<script>
import moment from 'moment-timezone'
import ApiService from '@/services/CommonApiService.js'
export default {
  data() {
    return {
      moment,
      userLang: navigator.language || navigator.userLanguage,
      screenWidth: window.innerWidth,
      form: {
        testerName: '',
        productId: '',
        pod: '',
        position: '',
        comments: ''
      },
      formRules: this.initFormRules(),
      products: [],
      podsOptions: [],
      positionOptions: this.initPositionOptions(),
      incompleteRunRecord: ''
    }
  },
  props: {
    utcOffset: {
      type: String,
      required: true
    }
  },
  mounted() {
    // Fixed a problem with the filterable select box, which cannot pop up on the soft keyboard on IOS
    Array.from(document.getElementsByClassName('filter-selelct')).forEach(
      item => {
        item.children[0].children[0].removeAttribute('readOnly')
        item.children[0].children[0].onblur = function() {
          let _this = this
          setTimeout(() => {
            _this.removeAttribute('readOnly')
          }, 200)
        }
      }
    )

    window.addEventListener('resize', this.getScreenWidth)
    this.loadAllProducts()
    this.loadAllPods()
    //block out old data
    let storedRecord = JSON.parse(localStorage.getItem('incomplete_run'))
    if (storedRecord && !storedRecord.charData.startedTime) {
      localStorage.removeItem('incomplete_run')
    }
    this.incompleteRunRecord = JSON.parse(
      localStorage.getItem('incomplete_run')
    )
  },
  watch: {
    '$store.state.locale.currentLocale': function() {
      this.positionOptions = this.initPositionOptions()
      // this.formRules = this.initFormRules()
    }
  },
  methods: {
    initFormRules() {
      return {
        testerName: [
          {
            required: true,
            message: this.$t('text.tester_required'),
            trigger: 'blur'
          }
        ],
        productId: [
          {
            required: true,
            message: this.$t('text.product_required'),
            trigger: 'change'
          }
        ],
        pod: [
          {
            required: true,
            message: this.$t('text.pod_required'),
            trigger: 'change'
          }
        ],
        position: [
          {
            required: true,
            message: this.$t('text.position_required'),
            trigger: 'change'
          }
        ],
        comments: [
          {
            required: true,
            message: this.$t('text.weight_required'),
            trigger: 'blur'
          }
        ]
      }
    },
    initPositionOptions() {
      return [
        {
          label: this.$t('text.lying_left'),
          value: 'Lying Left'
        },
        {
          label: this.$t('text.lying_right'),
          value: 'Lying Right'
        },
        {
          label: this.$t('text.lying_back'),
          value: 'Lying Back'
        },
        {
          label: this.$t('text.lying_front'),
          value: 'Lying Front'
        },
        {
          label: this.$t('text.sit'),
          value: 'Sit'
        },
        {
          label: this.$t('text.stand'),
          value: 'Stand'
        }
      ]
    },
    getScreenWidth() {
      this.screenWidth = window.innerWidth
    },
    goContinue() {
      this.$parent.$refs.runContinue.isContinue = true
      this.$parent.$refs.runContinue.charData = this.incompleteRunRecord.charData
      this.$parent.$refs.runContinue.volData = this.incompleteRunRecord.volData
      this.$parent.$refs.runContinue.commentData = this.incompleteRunRecord.commentData
      this.toContinuePage()
    },
    goStart() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.$parent.$refs.runContinue.charData = {
            ...this.form,
            startedTime: moment().format('YYYY-MM-DD HH:mm:ss'),
            productName: this.getProductName(this.form.productId)
          }
          this.toContinuePage()
        }
      })
    },
    getProductName(productId) {
      let productName = ''
      this.products.forEach(product => {
        if (product.id === productId) {
          productName = product.productName
        }
      })
      return productName
    },
    toContinuePage() {
      this.$refs.form.resetFields()
      this.$parent.haveInit = true
      this.$nextTick(() => {
        this.$parent.$refs.runContinue.isFinished = false
        this.$parent.$refs.runContinue.initChart()
        this.$parent.$refs.runContinue.chartTimer = setInterval(
          this.$parent.$refs.runContinue.getPodData,
          3000
        )
      })
    },
    loadAllProducts() {
      const user = JSON.parse(localStorage.getItem('user'))
      ApiService.GetProductsById(user.id).then(response => {
        this.products = response.data.data
      })
    },
    loadAllPods() {
      ApiService.GetConfiguration().then(response => {
        this.podsOptions = response.data.pods.map(item => {
          return {
            value: item.podId
          }
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/css/theme.scss';

.app-card {
  padding: 20px 24px;
}

.form-actions {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
  margin-top: 16px;
}

.incomplete-hint {
  font-size: 12px;
  color: #f56c6c;
  margin-right: 4px;
}

/deep/ .el-form-item__label {
  font-size: 12px;
  color: var(--text2, #6b7280);
  line-height: 1.4;
  padding: 0;
  margin-bottom: 4px;
}

/deep/ .el-form-item {
  margin-bottom: 14px;
}
</style>
